import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BackpackIconsModule } from 'app/backpack-icons/backpack-icons.module';
import { ButtonComponent } from './button/button.component';
import { DialogBodyComponent } from './dialog-modal/dialog-body.component';
import { DialogContentComponent } from './dialog-modal/dialog-content.component';
import { DialogFooterComponent } from './dialog-modal/dialog-footer.component';
import { DialogHeaderComponent } from './dialog-modal/dialog-header.component';
import { DialogService } from './dialog-modal/dialog.service';
import { ActionMenuComponent, ActionMenuItemComponent } from './menu/menu.component';
import { PressableTileComponent } from './pressable-tile/pressable-tile.component';
import { ResolveAssetPipe } from './resolve-asset.pipe';
import { BetaPillComponent } from './sidenav/beta-pill.component';
import { SidenavFloatingMenuComponent } from './sidenav/sidenav-floating-menu.component';
import { SidenavMenuComponent } from './sidenav/sidenav-menu.component';
import { TagComponent } from './tag/tag.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { UploadStudentListComponent } from './upload-student-list/upload-student-list.component';

@NgModule({
	imports: [
		// Pipes
		ResolveAssetPipe,

		// Components
		ButtonComponent,
		BetaPillComponent,
		CommonModule,
		SidenavFloatingMenuComponent,
		SidenavMenuComponent,
		TagComponent,
		TooltipComponent,
		PressableTileComponent,
		DialogContentComponent,
		DialogHeaderComponent,
		DialogBodyComponent,
		DialogFooterComponent,
		ActionMenuComponent,
		ActionMenuItemComponent,
		UploadStudentListComponent,
	],
	exports: [
		// Pipes
		ResolveAssetPipe,

		// Components
		ButtonComponent,
		BetaPillComponent,
		SidenavFloatingMenuComponent,
		SidenavMenuComponent,

		TagComponent,
		TooltipComponent,
		BackpackIconsModule,
		PressableTileComponent,
		DialogContentComponent,
		DialogHeaderComponent,
		DialogBodyComponent,
		DialogFooterComponent,
		ActionMenuComponent,
		ActionMenuItemComponent,
	],
	providers: [DialogService],
})
export class BackpackModule {}
